import { Node_Type } from "./../wix-rich-content-common";
const PAGE_SIZE = 25;
const WAIT_INTERVAL = 300;
const DEFAULTS = Object.freeze({
  config: {
    size: "content",
    alignment: "center"
  },
  configViewer: {
    sizes: { desktop: "original", mobile: "original" }
    // original or downsizedSmall are supported
  }
});
const gifModals = {
  insert: `${Node_Type.GIF}.insert`,
  replace: `${Node_Type.GIF}.replace`
};
const GIF_BUTTONS = {
  alignment: `${Node_Type.GIF}.alignment`,
  size: `${Node_Type.GIF}.size`
};
const imagePlaceholder = (
  // eslint-disable-next-line max-len
  "data:image/webp;base64, UklGRtgAAABXRUJQVlA4IMwAAABQFgCdASomASYBPhkMhUIhBAUABABhLS3cLuwjaAE9gHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99snIe+2TkPfbJyHvtk5D32ych77ZOQ99qwAAP7/9viAAAAAAAAAAAAAAAA="
);
export {
  DEFAULTS,
  GIF_BUTTONS,
  PAGE_SIZE,
  WAIT_INTERVAL,
  gifModals,
  imagePlaceholder
};
//# sourceMappingURL=constants.js.map
